(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-gruns"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('.hero-gruns');
    roots.forEach(function(root) {
      var sid = root.getAttribute('data-section-id');
      var dataEl = root.querySelector('[data-hero-ingredients]');
      if (!dataEl) return;
      var ingredients;
      try { ingredients = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!ingredients || !ingredients.length) return;

      var slots = root.querySelectorAll('.hg-slot');
      if (!slots.length) return;

      // Clockwise rotation order: tl(0) -> tr(1) -> br(3) -> bl(2)
      var corner = [0, 1, 3, 2];
      var flatOrder = [];

      ingredients.forEach(function(ing, i) {
        var slotIdx = corner[i % 4];
        var slotEl = slots[slotIdx];
        var cardIdx = slotEl.children.length;
        var card = document.createElement('div');
        card.className = 'hg-card';
        var padded = String(i + 1).padStart(2, '0');
        card.innerHTML =
          '<div class="row">' +
            '<span class="icon"><img src="' + ing.icon_url + '" alt="" loading="lazy"></span>' +
            '<span class="col">' +
              '<span class="function">' + ing.fn + '</span>' +
              '<span class="ingredient">' + ing.name + '</span>' +
            '</span>' +
          '</div>' +
          '<span class="index">' + padded + ' / ' + String(ingredients.length).padStart(2, '0') + '</span>';
        slotEl.appendChild(card);
        flatOrder.push([slotIdx, cardIdx]);
      });

      var pos = 0;
      var prev = null;
      var timer = null;

      function showNext() {
        var pair = flatOrder[pos];
        var slotIdx = pair[0];
        var cardIdx = pair[1];
        var slotEl = slots[slotIdx];
        var nextCard = slotEl.children[cardIdx];

        if (prev && prev !== nextCard) {
          prev.classList.remove('active');
          prev.classList.add('exiting');
          var exiting = prev;
          setTimeout(function() { exiting.classList.remove('exiting'); }, 700);
        }
        slots.forEach(function(s) {
          Array.prototype.forEach.call(s.children, function(c) {
            if (c !== prev && c !== nextCard) c.classList.remove('active', 'exiting');
          });
        });
        nextCard.classList.remove('exiting');
        nextCard.classList.add('active');
        prev = nextCard;

        pos = (pos + 1) % flatOrder.length;
      }

      function start() { stop(); showNext(); timer = setInterval(showNext, 1400); }
      function stop()  { if (timer) { clearInterval(timer); timer = null; } }

      var stage = root.querySelector('.hg-stage');
      if (stage) {
        stage.addEventListener('mouseenter', stop);
        stage.addEventListener('mouseleave', start);
      }

      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.pdp-main');
    roots.forEach(function (root) {
      // Gallery thumb swap
      var mainImg = root.querySelector('#gallery-main-img');
      root.querySelectorAll('.gallery-thumb').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var url = btn.getAttribute('data-img');
          if (url && mainImg) mainImg.src = url;
          root.querySelectorAll('.gallery-thumb').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
      });

      // Dynamic stock bar — slowly ticks down across the session so the bar
      // feels alive. Starts at the schema-set %; drops by 1% every 60–90s,
      // floored at 22% so the bar always reads as "almost gone but visible".
      // sessionStorage key is versioned (_v2) so a copy bump (e.g. 30 → 28)
      // doesn't get stuck behind older cached values for returning visitors.
      var stockEl = root.querySelector('[data-stock-pct]');
      var stockFill = root.querySelector('[data-stock-fill]');
      var stockNum = root.querySelector('[data-stock-num]');
      if (stockEl && stockFill && stockNum) {
        var STORAGE_KEY = 'ooedn_stock_pct_v2';
        var FLOOR = 22;
        var startPct = parseInt(stockEl.getAttribute('data-stock-pct'), 10) || 28;
        var saved = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
        var current = saved && saved <= startPct && saved >= FLOOR ? saved : startPct;
        function setStock(pct) {
          if (pct < FLOOR) pct = FLOOR;
          current = pct;
          stockFill.style.width = pct + '%';
          stockNum.textContent = pct;
          sessionStorage.setItem(STORAGE_KEY, String(pct));
        }
        setStock(current);
        function scheduleTick() {
          var nextDelay = 60000 + Math.floor(Math.random() * 30000); // 60–90s
          setTimeout(function () {
            setStock(current - 1);
            scheduleTick();
          }, nextDelay);
        }
        scheduleTick();
      }

      // Live activity rotator — cycles through user-provided messages.
      // Shuffled on each visit + slightly randomized cadence so the loop
      // never feels like a 5-message reel. With ~50 messages in the default
      // pool, any one line only resurfaces every ~3 minutes.
      var liveEl = root.querySelector('[data-live-activity-text]');
      var liveBadge = root.querySelector('[data-live-activity]');
      var msgScript = root.querySelector('[data-live-activity-messages]');
      if (liveEl && liveBadge && msgScript) {
        var raw = msgScript.textContent.trim();
        var messages;
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) messages = parsed;
          else
            messages = parsed
              .split(/\r?\n/)
              .map(function (s) {
                return s.trim();
              })
              .filter(Boolean);
        } catch (e) {
          messages = raw
            .split(/\r?\n/)
            .map(function (s) {
              return s.trim();
            })
            .filter(Boolean);
        }
        // Fisher–Yates shuffle so each visitor sees a different order
        for (var i = messages.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = messages[i];
          messages[i] = messages[j];
          messages[j] = tmp;
        }
        if (messages.length > 1) {
          var idx = 0;
          // Set initial visible message to a random pick
          liveEl.textContent = messages[idx];
          function tick() {
            liveBadge.classList.add('is-fading');
            setTimeout(function () {
              idx = (idx + 1) % messages.length;
              liveEl.textContent = messages[idx];
              liveBadge.classList.remove('is-fading');
              // Random next delay: 2.8s to 4.6s — never robotic
              var nextDelay = 2800 + Math.floor(Math.random() * 1800);
              setTimeout(tick, nextDelay);
            }, 400);
          }
          setTimeout(tick, 3200 + Math.floor(Math.random() * 1200));
        }
      }

      // Plan radio → CTA + variant id swap
      var ctaText = root.querySelector('[data-pdp-cta-text]');
      var variantInput = root.querySelector('[data-pdp-variant-id]');
      var selling_id_send = root.querySelector('input[name="selling_plan"]');
      var variantQty = root.querySelector('input[name="quantity"]');

      root.querySelectorAll('input[name="plan"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) {
            if (ctaText) ctaText.textContent = r.getAttribute('data-cta') || '';
            if (variantInput) variantInput.value = r.getAttribute('data-variant') || variantInput.value;
            
            // Added on 22/5
            var planId = r.getAttribute('data-selling-plan');
            var varQty = r.getAttribute("data-qty");
            console.log(planId);

            //  root.querySelector('[selling_plan]').value = planId;
            if (selling_id_send) {
              selling_id_send.value = r.getAttribute('data-selling-plan') || '';
            }
            if (variantQty){
              variantQty.value = r.getAttribute('data-qty') || '';
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-mainProductRefactor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.pdp-main');
    roots.forEach(function (root) {
      // Gallery thumb swap
      var mainImg = root.querySelector('#gallery-main-img');
      root.querySelectorAll('.gallery-thumb').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var url = btn.getAttribute('data-img');
          if (url && mainImg) mainImg.src = url;
          root.querySelectorAll('.gallery-thumb').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
      });

      // Dynamic stock bar — slowly ticks down across the session so the bar
      // feels alive. Starts at the schema-set %; drops by 1% every 60–90s,
      // floored at 22% so the bar always reads as "almost gone but visible".
      // sessionStorage key is versioned (_v2) so a copy bump (e.g. 30 → 28)
      // doesn't get stuck behind older cached values for returning visitors.
      var stockEl = root.querySelector('[data-stock-pct]');
      var stockFill = root.querySelector('[data-stock-fill]');
      var stockNum = root.querySelector('[data-stock-num]');
      if (stockEl && stockFill && stockNum) {
        var STORAGE_KEY = 'ooedn_stock_pct_v2';
        var FLOOR = 22;
        var startPct = parseInt(stockEl.getAttribute('data-stock-pct'), 10) || 28;
        var saved = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10);
        var current = saved && saved <= startPct && saved >= FLOOR ? saved : startPct;
        function setStock(pct) {
          if (pct < FLOOR) pct = FLOOR;
          current = pct;
          stockFill.style.width = pct + '%';
          stockNum.textContent = pct;
          sessionStorage.setItem(STORAGE_KEY, String(pct));
        }
        setStock(current);
        function scheduleTick() {
          var nextDelay = 60000 + Math.floor(Math.random() * 30000); // 60–90s
          setTimeout(function () {
            setStock(current - 1);
            scheduleTick();
          }, nextDelay);
        }
        scheduleTick();
      }

      // Live activity rotator — cycles through user-provided messages.
      // Shuffled on each visit + slightly randomized cadence so the loop
      // never feels like a 5-message reel. With ~50 messages in the default
      // pool, any one line only resurfaces every ~3 minutes.
      var liveEl = root.querySelector('[data-live-activity-text]');
      var liveBadge = root.querySelector('[data-live-activity]');
      var msgScript = root.querySelector('[data-live-activity-messages]');
      if (liveEl && liveBadge && msgScript) {
        var raw = msgScript.textContent.trim();
        var messages;
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) messages = parsed;
          else
            messages = parsed
              .split(/\r?\n/)
              .map(function (s) {
                return s.trim();
              })
              .filter(Boolean);
        } catch (e) {
          messages = raw
            .split(/\r?\n/)
            .map(function (s) {
              return s.trim();
            })
            .filter(Boolean);
        }
        // Fisher–Yates shuffle so each visitor sees a different order
        for (var i = messages.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = messages[i];
          messages[i] = messages[j];
          messages[j] = tmp;
        }
        if (messages.length > 1) {
          var idx = 0;
          // Set initial visible message to a random pick
          liveEl.textContent = messages[idx];
          function tick() {
            liveBadge.classList.add('is-fading');
            setTimeout(function () {
              idx = (idx + 1) % messages.length;
              liveEl.textContent = messages[idx];
              liveBadge.classList.remove('is-fading');
              // Random next delay: 2.8s to 4.6s — never robotic
              var nextDelay = 2800 + Math.floor(Math.random() * 1800);
              setTimeout(tick, nextDelay);
            }, 400);
          }
          setTimeout(tick, 3200 + Math.floor(Math.random() * 1200));
        }
      }

      // Plan radio → CTA + variant id swap
      var ctaText = root.querySelector('[data-pdp-cta-text]');
      var variantInput = root.querySelector('[data-pdp-variant-id]');
      var selling_id_send = root.querySelector('input[name="selling_plan"]');
      var variantQty = root.querySelector('input[name="quantity"]');

      root.querySelectorAll('input[name="plan"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) {
            if (ctaText) ctaText.textContent = r.getAttribute('data-cta') || '';
            if (variantInput) variantInput.value = r.getAttribute('data-variant') || variantInput.value;

            // Added on 22/5
            var planId = r.getAttribute('data-selling-plan');
            var varQty = r.getAttribute('data-qty');
            console.log(planId);

            //  root.querySelector('[selling_plan]').value = planId;
            if (selling_id_send) {
              selling_id_send.value = r.getAttribute('data-selling-plan') || '';
            }
            if (variantQty) {
              variantQty.value = r.getAttribute('data-qty') || '';
            }
          }
        });
      });


    });



$(document).on('click', '.btn-cart', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const form = $(this).closest('form');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        success: function(response) {
            console.log('Added to cart:', response);
            window.location.href = '/checkout';
        },
        error: function(xhr) {
          alert("Out of Stock")
            console.log('Error:', xhr.responseText);
        }
    });

    return false;
});


    
  })();

  } catch(e) { console.error(e); }
})();
})();
